module.exports = __webpack_public_path__ + "img/puzzle2_pl.738afa39.svg";